import { CircuitBenefitType } from '@/types/circuits/CircuitBenefitType';

export const parseCircuitBenefitType = (type: CircuitBenefitType) => {
  switch (type) {
    case 'Transport':
      return 'transport';
    case 'Activités':
      return 'activities';
    case 'Repas':
      return 'meals';
    case 'Hébergements':
      return 'accommodations';
  }
};
